import script from "./ AllocateSpace.vue?vue&type=script&setup=true&lang=js"
export * from "./ AllocateSpace.vue?vue&type=script&setup=true&lang=js"

import "./ AllocateSpace.vue?vue&type=style&index=0&id=7bb3da56&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bb3da56"]])

export default __exports__